import React from 'react';

import AdminControlerComponent from '../../../components/Admin/AdminControler';

function AdminControllerPage(){
    return (
        <AdminControlerComponent />
    )
}

export default AdminControllerPage;